import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import FlightRoute from '../entities/flight/flightRoute';

import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations';

interface FlightRouteState extends ListState<FlightRoute> {
  flightRoute: FlightRoute;
  editFlightRoute: FlightRoute;
}

class FlightRouteMutations extends ListMutations<FlightRoute> {}

class FlightRouteModule extends ListModule<FlightRouteState, any, FlightRoute> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<FlightRoute>(),
    loading: false,
    editFlightRoute: new FlightRoute(),
    selectFlightRoute: new FlightRoute(),
  };
  actions = {
    async selectFlightRoute(
      context: ActionContext<FlightRouteState, any>,
      payload: any
    ) {
      context.state.editFlightRoute = payload.data;
    },

    async saveFlightRoute(
      context: ActionContext<FlightRouteState, any>,
      payload: any
    ) {
      let reponse = await Ajax.post(
        '/api/services/app/Flight/SaveOrUpdateFlightRoute',
        payload.data
      );

      let page = reponse.data.result as PageResult<FlightRoute>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async updateFlightRoute(
      context: ActionContext<FlightRouteState, any>,
      payload: any
    ) {
      let reponse = await Ajax.post(
        '/api/services/app/Flight/SaveOrUpdateFlightRoute',
        payload.data
      );

      let page = reponse.data.result as PageResult<FlightRoute>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async getFlightRoutes(
      context: ActionContext<FlightRouteState, any>,
      payload: any
    ) {
      // context.state.loading=true;
      let reponse = await Ajax.get(
        '/api/services/app/Flight/GetFlightRoutes',
        payload.data
      );

      // context.state.loading=false;
      let page = reponse.data.result as PageResult<FlightRoute>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async deleteFlightRoute(
      context: ActionContext<FlightRouteState, any>,
      payload: any
    ) {
      await Ajax.delete(
        '/api/services/app/Flight/DeleteFlightRoute?id=' + payload.payload
      );
    },
  };
  mutations = {
    setCurrentPage(state: FlightRouteState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: FlightRouteState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const flightRouteModule = new FlightRouteModule();
export default flightRouteModule;
